import { Snackbar } from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";
import update from "immutability-helper";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";

import { useEffect, useState } from "react";
import { Alert } from "@material-ui/lab";
import React from "react";
import $ from "jquery";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Check from "@material-ui/icons/Check";
import SettingsIcon from "@material-ui/icons/Settings";

import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import DataTableTransactionEndRecieve from "../../ui/DataTableTransactionEndRecieve";
import SellingService from "../../services/SellingService";
import { Link } from "react-router-dom";
import DataTableTransactionSell from "../../ui/DataTableTransactionSell";
import withLoader from './../../components/layouts/WithLoader';
const styles = {
  container: (base) => ({
    ...base,
    flex: 1,
  }),
};

const useQontoStepIconStyles = makeStyles({
  root: {
    color: "#eaeaf0",
    display: "flex",
    height: 22,
    alignItems: "center",
  },
  active: {
    color: "#000000",
  },
  circle: {
    width: 8,
    height: 8,
    color: "#fff",
    borderRadius: "50%",
    backgroundColor: "#000000",
  },
  completed: {
    color: "#000000",
    zIndex: 1,
    fontSize: 18,
  },
});

function QontoStepIcon(props) {
  const classes = useQontoStepIconStyles();
  const { active, completed } = props;

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
      })}
    >
      {completed ? (
        <Check className={classes.completed} />
      ) : (
        <div className={classes.circle} />
      )}
    </div>
  );
}

QontoStepIcon.propTypes = {
  active: PropTypes.bool,

  completed: PropTypes.bool,
};

const useColorlibStepIconStyles = makeStyles({
  root: {
    "& .MuiStepIcon-root.MuiStepIcon-active ": {
      backgroundColor: "#ccc",
      zIndex: 1,
      color: "#000",
      width: 50,
      height: 50,
      display: "flex",
      borderRadius: "50%",
      justifyContent: "center",
      alignItems: "center",
    },
  },
  active: {
    "& .MuiStepIcon-root.MuiStepIcon-active ": {
      color: "#000000",
    },
  },
  completed: {
    "& .MuiStepIcon-root.MuiStepIcon-completed": {
      color: "#000000",
    },
  },
});

function ColorlibStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const { active, completed } = props;

  const icons = {
    1: <SettingsIcon />,
  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {icons[String(props.icon)]}
    </div>
  );
}

ColorlibStepIcon.propTypes = {
  active: PropTypes.bool,

  completed: PropTypes.bool,

  icon: PropTypes.node,
};

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiStepIcon-root.MuiStepIcon-active ": {
      width: "100%",
      color: "#000000",
    },
    "& .MuiStepIcon-root.MuiStepIcon-completed": {
      color: "#000000",
    },
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  icon: {
    color: "#000",
  },
}));

function getSteps() {
  return ["Confirmer la commande", "Finaliser"];
}

const SendAllProductsPurchaseOrder = ({ startLoading, stopLoading }) => {
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const [infoAlertText, setInfoAlertText] = useState();
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const steps = getSteps();
  const [warehouseSourceId, setWarehouseSourceId] = useState(0);
  const [product, setProduct] = React.useState(0);
  const [currentQteProductPurchase, setCurrentQteProductPurchase] =
    React.useState("0");
  const [amount, setAmount] = React.useState(0);
  const [productTableData, setProductTableData] = React.useState([]);
  const [productMapById, setProductMapById] = React.useState([]);
  const [factureOrPurchaseOrderReference, setFactureOrPurchaseOrderReference] =
    useState("");
  const [selectedOption, setSelectedOption] = useState(null);
  const animatedComponents = makeAnimated();
  const [products, setProducts] = React.useState([{}]);
  const [showElement, setShowElement] = useState([]);
  const [document, setDocument] = useState(null);
  const [transactions, setTransactions] = useState(null);
  const [disableTerminer, setDisableTerminer] = useState(false);

  const [productSelectPlaceHolder, setProductSelectPlaceHolder] =
    useState("Choisir...");

  const [note, setNote] = useState();

  const [typeProduit, setTypeProduit] = useState(1);

  $(".custom-file-input").on("change", function () {
    var fileName = $(this).val().split("\\").pop();
    $(this).siblings(".custom-file-label").addClass("selected").html(fileName);
  });
  const handlerChangeQt = (event) => {
    setAmount(event.target.value);
  };

  useEffect(() => {
    if (localStorage.getItem("status") == null) {
      setShowElement(["notConnected"]);
    } else {
      let user = JSON.parse(localStorage.getItem("user"));
      setShowElement(JSON.parse(localStorage.getItem("status")));
    }
    startLoading()
    SellingService.getSalesByRefCByRefBDC(
      sessionStorage.getItem("refBDC"),
      getCurrentUserId()
    )
      .then((response) => {
        console.log("response", response);
        if (Object.keys(response.data)[0] === "InvalidReference") {
          setOpenInfoAlert(true);
          setInfoAlertText("Info : la réference est invalide");
        } else if (Object.keys(response.data)[0] === "RelatedToFacture") {
          setOpenInfoAlert(true);
          setInfoAlertText("Info : cette achat est liée a une facture");
        } else if (Object.keys(response.data)[0] === "AlreadyCompleted") {
          setOpenInfoAlert(true);
          setInfoAlertText("Info :l'operation est terminé");
        } else if (Object.keys(response.data)[0] === "error") {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : Aucun bon de commande de ce référence");
        } else {
          setProducts([{}]);
          response.data.ProductsSales.map((element) => {
            setProducts((oldArray) => [
              ...oldArray,
              {
                value: element.idProductSale,
                label: element.productName,
                customElements: {
                  quantity: element.quantity,
                  currentQte: element.currentQte,
                },
              },
            ]);
          });
          response.data.ProductsSales.map((element, index) => {
            setProductTableData((previoustate) => [
              ...previoustate,
              {
                idProductPurchase: element.idProductSale,
                stockedQte: "" + element.currentQte,
                productName: element.productName,
                type: typeProduit,
                note: note,
              },
            ]);
          });
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connexion");
      }).finally(() => {
        stopLoading();
      });
  }, []);

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };
  const onChangeSelectedProduct = (selectedOptionn) => {
    setSelectedOption();
    setProduct(selectedOptionn.value);
    setProductSelectPlaceHolder(selectedOptionn.label);
    setCurrentQteProductPurchase(selectedOptionn.customElements.currentQte);
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  const onChangeFactureOrPurchaseOrderReferenceHandler = (event) => {
    setFactureOrPurchaseOrderReference(event.target.value);
  };

  const onAddProductToList = (event) => {
    let name = null;
    let exist = false;
    let indexInDataTable;
    try {
      productMapById.forEach((element, index) => {
        if (element.id === product) {
          indexInDataTable = index;
          exist = true;
          throw "Break";
        }
      });
    } catch (e) {
      if (e !== "Break") throw e;
    }

    try {
      products.forEach((element) => {
        if (element.idProductPurchase === product) {
          name = element.productName;
          throw "Break";
        }
      });
    } catch (e) {
      if (e !== "Break") throw e;
    }
    if (amount > parseInt(currentQteProductPurchase)) {
      setOpenErrorAlert(true);
      setErrorAlertText(
        "Erreur : la quantité de ce produit est indisponible  "
      );
    } else if (amount === 0) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : la quantité doit etre sup a zero");
    } else {
      if (!exist && amount !== 0) {
        setProductTableData((previoustate) => [
          ...previoustate,
          {
            idProductPurchase: product,
            stockedQte: amount,
            productName: productSelectPlaceHolder,
            type: typeProduit,
            note: note,
          },
        ]);
      } else if (exist && amount !== 0) {
        let typeProd = productTableData[indexInDataTable].type;
        if (typeProd !== typeProduit) {
          setProductTableData((previoustate) => [
            ...previoustate,
            {
              idProductPurchase: product,
              stockedQte: amount,
              productName: productSelectPlaceHolder,
              type: typeProduit,
              note: note,
            },
          ]);
        } else {
          let newState = update(productTableData, {
            [indexInDataTable]: {
              qte: { $set: amount },
            },
          });

          setOpenInfoAlert(true);
          setInfoAlertText(
            "Info : tu as actualisé la quantité de produit :  " +
              productSelectPlaceHolder
          );
          setProductTableData(newState);
        }
      }
    }
  };

  const handleNext = () => {
    if (activeStep === 0) {
      if (sessionStorage.getItem("refBDC") === "") {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : la réference est vide");
      } else {
        // SellingService.getSalesByRefCByRefBDC(
        //   factureOrPurchaseOrderReference,
        //   getCurrentUserId()
        // )
        //   .then((response) => {
        //     console.log("response", response);
        //     if (Object.keys(response.data)[0] === "InvalidReference") {
        //       setOpenInfoAlert(true);
        //       setInfoAlertText("Info : la réference est invalide");
        //     } else if (Object.keys(response.data)[0] === "RelatedToFacture") {
        //       setOpenInfoAlert(true);
        //       setInfoAlertText("Info : cette achat est liée a une facture");
        //     } else if (Object.keys(response.data)[0] === "AlreadyCompleted") {
        //       setOpenInfoAlert(true);
        //       setInfoAlertText("Info :l'operation est terminé");
        //     } else if (Object.keys(response.data)[0] === "error") {
        //       setOpenErrorAlert(true);
        //       setErrorAlertText(
        //         "Erreur : Aucun bon de commande de ce référence"
        //       );
        //     } else {
        //       setProducts([{}]);
        //       response.data.ProductsSales.map((element) => {
        //         setProducts((oldArray) => [
        //           ...oldArray,
        //           {
        //             value: element.idProductSale,
        //             label: element.productName,
        //             customElements: {
        //               quantity: element.quantity,
        //               currentQte: element.currentQte,
        //             },
        //           },
        //         ]);
        //       });
        //       setActiveStep((prevActiveStep) => prevActiveStep + 1);
        //     }
        //   })
        //   .catch(() => {
        //     setOpenErrorAlert(true);
        //     setErrorAlertText("Erreur : il ya un probléme de connexion");
        //   });
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
    } else if (activeStep === 1) {
      let validatePurchaseOrderToRealWarehouseModel = {
        idWarhouse: warehouseSourceId,
        idUser: getCurrentUserId(),
        productStockedByWarehouseModels: productTableData,
        reference: sessionStorage.getItem("refBDC"),
        pathBonDeLivraison: "any",
      };

      console.log(
        "validatePurchaseOrderToRealWarehouseModel",
        JSON.stringify(validatePurchaseOrderToRealWarehouseModel)
      );
      setDisableTerminer(true)
      startLoading();
      SellingService.validateSalesOrderToRealWarehouse(
        validatePurchaseOrderToRealWarehouseModel
      )
        .then((response) => {
          console.log("validateSalesOrderToRealWarehouse", response);
          if (response.data.success) {
            setOpenSuccessAlert(true);
            setTransactions(response.data?.transactionOperationsResponse);
            setDocument(response.data?.success);
            setSuccessAlertText("Enregistrement avec succées");
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
          } else if (response.data.error) {
            setOpenErrorAlert(true);
            setErrorAlertText(
              "Erreur :"+response.data.error
            );
          } else if (Object.keys(response.data)[0] === "IsCompleted") {
            setOpenInfoAlert(true);
            setInfoAlertText("Info : l'opération est déja terminée");
          } else if (Object.keys(response.data)[0] === "InvalidateReference") {
            setOpenInfoAlert(true);
            setInfoAlertText(
              "Info : la réference n'est pas valide "
            );
          }
        })
        .catch((error) => {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : "+error);
        }).finally(() => {
          stopLoading();
        });
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const columns = [
    {
      dataField: "productName",
      text: "Libellé",
      headerAlign: "center",
    },
    {
      dataField: "type",
      text: "type",
      align: "center",
      headerAlign: "center",
      formatter: lotFormatter,
    },
    {
      dataField: "stockedQte",
      text: "Qte",
      align: "center",
      headerAlign: "center",
    },
  ];
  function handleTableChange({ productTableData }) {
    return productTableData;
  }
  //   const onValueChangeTypeProduit = (event) => {
  //     if (event.target.value === "1") {
  //       setTypeProduit(1);
  //     } else if (event.target.value === "2") {
  //       setTypeProduit(2);
  //     } else if (event.target.value === "3") {
  //       setTypeProduit(3);
  //     }
  //   };
  //   const onChangeNoteHandler = (event) => {
  //     setNote(event.target.value);
  //   };
  //   const typeProduitNote = () => {
  //     if (typeProduit === 2) {
  //       return (
  //         <div className="row">
  //           <div className="form-group col-sm-12">
  //             <label htmlFor="inputDescription">Note</label>
  //             <textarea
  //               placeholder="Saisir..."
  //               onChange={onChangeNoteHandler}
  //               id="inputDescription"
  //               className="form-control"
  //               rows={2}
  //               defaultValue={""}
  //             />
  //           </div>
  //         </div>
  //       );
  //     }
  //   };

  function lotFormatter(cell, row) {
    if (cell === 1) {
      return <span>Nouveau sortie</span>;
    } else if (cell === 3) {
      return <span>Sorti du retours</span>;
    }
  }

  function getStepContent(step) {
    switch (step) {
      case 0:
        return (
          <div>
            <div class="row">
              <div className="col-sm-12">
                <h5>Envoyer une commande au client</h5>
              </div>
            </div>

            <div class="row">
              <div className="col-sm-12">
                <div className="form-group">
                  {productTableData && (
                    <ToolkitProvider
                      keyField="idProduct"
                      data={productTableData}
                      columns={columns}
                      onTableChange={handleTableChange}
                    >
                      {(props) => (
                        <div className="row">
                          <BootstrapTable
                            {...props.baseProps}
                            striped
                            hover
                            condensed
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  )}
                </div>
              </div>
            </div>
          </div>
        );
     
      case 1:
        return (
          <div className="row">
            <span class="text-dark">
              Avant de cliquer sur terminé, vous devez être sûr des informations
              saisies
            </span>
          </div>
        );
      default:
        return "Unknown step";
    }
  }

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <ol class="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <Link to="/" style={{ color: "black" }}>
                    Home
                  </Link>
                </li>

                {/* <li className="breadcrumb-item">
                  <Link to="/bonsDeCommande" style={{ color: "black" }}>
                    Recevoir une commande
                  </Link>
                </li> */}
                <li
                  className="breadcrumb-item active"
                  style={{ color: "black" }}
                >
                  Sortir une commande
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      {/* <br /> */}
      <section className="content ">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-header">
                  <div className={classes.root}>
                    <Stepper activeStep={activeStep}>
                      {steps.map((label) => (
                        <Step key={label}>
                          <StepLabel>{label}</StepLabel>
                        </Step>
                      ))}
                    </Stepper>
                  </div>
                </div>

                {activeStep === steps.length ? (
                  <div>
                    <div class="card-body">
                      <div class="row" style={{ marginTop: 0 }}>
                        {document && transactions && document!==null && transactions.size>0 && (
                          <DataTableTransactionSell
                            state={document?.stateLivraison}
                            refFacture={document?.ref}
                            listProduits={transactions}
                          />
                        )}
                      </div>
                    </div>
                    <div class="card-footer" style={{ marginTop: "1%" }}>
                      <button
                        className="btn btn-dark float-right"
                        onClick={handleReset}
                      >
                        Réinitialiser
                      </button>
                    </div>
                  </div>
                ) : (
                  <div>
                    <div class="card-body">{getStepContent(activeStep)}</div>

                    <div class="card-footer" style={{ marginTop: "1%" }}>
                      <button
                        disabled={activeStep === 0}
                        className="btn btn-light"
                        onClick={handleBack}
                      >
                        Précédent
                      </button>

                      <button disabled={disableTerminer} className="btn btn-dark" onClick={handleNext}>
                        {activeStep === steps.length - 1
                          ? "Terminer"
                          : "Suivant"}
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      <Snackbar
        open={openInfoAlert}
        autoHideDuration={2000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="info">
          {infoAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(SendAllProductsPurchaseOrder);
